const Footer = () => {
  return (
    <>
      <div className="landing__footer">
        El seguro contratado es operado directamente por Cardif México Seguros
        de Vida S.A. de C.V. en lo sucesivo Cardif. El pago de siniestros es
        responsabilidad de Cardif, cualquier aclaración y/o controversia
        vinculada con el seguro será atendida por Cardif en términos del
        producto de seguro aquí descrito, así como de las condiciones generales
        aplicables, las cuales contienen los derechos y obligaciones de este
        seguro; por lo que el producto de seguro es independiente a cualquier
        producto o servicio que el cliente pudiese tener contratado con
        cualquier tercero.
      </div>
    </>
  );
};

export default Footer;
